import { useField } from "@unform/core";
import { useEffect, useRef } from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";

import Alert from "../../Components/Alert";
import Prefix from "../../Components/Prefix";
import * as S from "./styles";

import { useTheme } from "styled-components";

const Core = ({
  name,
  options,
  label,
  placeholder,
  alertType,
  alertMessage,
  size = "md",
  required,
  disabled,
  prefix,
  request,
  variant = "dark",
  ...rest
}) => {
  const theme = useTheme();
  const { fieldName, registerField } = useField(name);
  const inputRef = useRef(null);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "state.value",
      getValue: (ref) => {
        if (rest.isMulti) {
          if (!ref.state.selectValue) {
            return [];
          }
          return ref.state.selectValue.map((option) => option.value);
        } else {
          if (!ref.state.selectValue) {
            return "";
          }
          return ref.state.selectValue[0]
            ? ref.state.selectValue[0].value
            : rest.value;
        }
      },
      clearValue: (ref) => {
        ref.clearValue();
      },
    });
    //eslint-disable-next-line
  }, [fieldName, registerField, rest.isMulti]);

  const Control = ({ children, ...props }) => (
    <components.Control {...props}>
      {prefix && <Prefix size={size} {...prefix} />}
      {children}
    </components.Control>
  );

  const promiseOptions = async (inputValue) => {
    return await request(inputValue);
  };

  return (
    <S.Wrapper
      style={{
        gridArea: rest?.gridArea,
      }}
      variant={variant}
      {...rest}
    >
      <S.Label required={required} htmlFor={name}>
        {label}
      </S.Label>
      <AsyncSelect
        ref={inputRef}
        classNamePrefix="react-select"
        name={name}
        options={options}
        styles={S.CustomStyles(theme, size, alertType, disabled)}
        placeholder={placeholder}
        components={{ Control }}
        required={required}
        isDisabled={disabled}
        loadOptions={promiseOptions}
        {...rest}
      />
      {alertType && alertMessage && (
        <Alert type={alertType} message={alertMessage} size={size} />
      )}
    </S.Wrapper>
  );
};

export default Core;
